import { getRequestExperiments } from "@backmarket/nuxt-module-experiments/getRequestExperiments";
import { getMarkets } from "../app/utils/getMarkets.js";
import { getRequestCountryCode } from "./getRequestCountryCode.js";
export function getRequestMarket(event) {
  const experiments = getRequestExperiments(event);
  const enableEsUsContent = experiments["experiment.enableEsUsContent"] !== "disabled";
  const markets = getMarkets(enableEsUsContent);
  const countryCode = getRequestCountryCode(event);
  return markets[countryCode];
}
